import { httpClient, PaginationParams } from '../core/http';
import {
  AcceptOrganizationInvitationRequest,
  AcceptOrganizationInvitationResponse,
  CreateOrganizationInvitationRequest,
  OrganizationInvitation,
  OrganizationInvitationStatus,
  OrganizationMember,
} from '../types';

interface PaginatedResponse<T> {
  items: T[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}

export class OrganizationInvitationService {
  async listMembers(
    organizationId: number,
    pagination?: PaginationParams
  ): Promise<PaginatedResponse<OrganizationMember>> {
    const response = await httpClient.get<PaginatedResponse<OrganizationMember>>(
      `/v1/organizations/${organizationId}/members`,
      {
        params: pagination,
      }
    );
    return response.data;
  }

  async listInvitations(
    organizationId: number,
    filters?: {
      status?: OrganizationInvitationStatus | string;
      page?: number;
      page_size?: number;
    }
  ): Promise<PaginatedResponse<OrganizationInvitation>> {
    const response = await httpClient.get<PaginatedResponse<OrganizationInvitation>>(
      `/v1/organizations/${organizationId}/invitations`,
      {
        params: filters,
      }
    );
    return response.data;
  }

  async createInvitation(
    organizationId: number,
    payload: CreateOrganizationInvitationRequest
  ): Promise<OrganizationInvitation> {
    const response = await httpClient.post<OrganizationInvitation>(
      `/v1/organizations/${organizationId}/invitations`,
      payload
    );
    return response.data;
  }

  async revokeInvitation(
    organizationId: number,
    invitationId: number
  ): Promise<{ message: string }> {
    const response = await httpClient.delete<{ message: string }>(
      `/v1/organizations/${organizationId}/invitations/${invitationId}`
    );
    return response.data;
  }

  async removeMember(
    organizationId: number,
    userId: number
  ): Promise<{ message: string }> {
    const response = await httpClient.delete<{ message: string }>(
      `/v1/organizations/${organizationId}/members/${userId}`
    );
    return response.data;
  }

  async acceptInvitation(
    payload: AcceptOrganizationInvitationRequest
  ): Promise<AcceptOrganizationInvitationResponse> {
    const response = await httpClient.post<AcceptOrganizationInvitationResponse>(
      '/v1/organization-invitations/accept',
      payload
    );
    return response.data;
  }
}
